import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamMemberApiResponse } from '../../../types';
import { useRemoveTeamMember } from '../../hooks/use-remove-team-member';

export function RemoveMemberModal({
  member,
  isOpen,
  closeModal,
}: {
  member: TeamMemberApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: removeMember, isPending, reset } = useRemoveTeamMember();

  const handleClose = () => {
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!member) {
      return;
    }

    removeMember(member.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleSubmit}
      loading={isPending}
      title={t('features:account.components.modals.remove_member_modal.header', {
        name: member?.name ?? '',
      })}
      confirmText={t('buttons:remove')}
      message={t('features:account.components.modals.remove_member_modal.body', {
        name: member?.name ?? '',
      })}
    />
  );
}
